import { SubmitEvent, SyntheticEvent, useState } from 'react'
import { Autocomplete, AutocompleteProps, FilterOptionsState } from '@mui/material'
import { champSansAccent, getIdNoeudsAscendants } from '../Utils/fonctions'
import { useFetchContext } from '../../hook/UseFetchContext'
import { CLEAR_AGENT, SET_NOEUD_OUVERT, SET_NOEUD_SELECTED } from '../../lib/typeKey'
import { renderInputAccessibleGenerator } from '../commun/renderInputAccessibleGenerator'
import { searchUnite } from '../Utils/searchUtils'
import { getLanguePourLesUnitesPasEnFrancais } from './langUnite'

export default function RechercheUnite() {
  const { state, dispatch } = useFetchContext()
  const noeuds = state.dimensionState.noeuds
  const [inputValue, setInputValue] = useState<string | null>(null)

  const getListeIdNoeudAscendants = (noeud: INoeudDimension | null) => {
    let noeudsAscendants: string[] = []
    let idNoeudSelected = null
    if (noeud) {
      idNoeudSelected = noeud.identifiantNoeudDimension
      noeudsAscendants = getIdNoeudsAscendants(noeuds, noeud)
    } else {
      // s'il n'y a pas de noeud, suppression des agents dans le store
      dispatch({ type: CLEAR_AGENT })
    }
    if (typeof noeud !== 'object') {
      dispatch({ type: CLEAR_AGENT })
    }
    dispatch({ type: SET_NOEUD_OUVERT, payload: noeudsAscendants })
    dispatch({ type: SET_NOEUD_SELECTED, payload: idNoeudSelected })
  }

  const label = 'Recherche par libellé ou par timbre'

  const miseEnformeUniteName = (unite: INoeudDimension | string) => {
    if (typeof unite === 'string') return unite
    if (unite.libelle) {
      return unite.libelle
    }
    return ''
  }

  const onChange = (_: SyntheticEvent<Element, Event> | null, value: string | INoeudDimension | null) => {
    if (typeof value === 'string') {
      setInputValue(champSansAccent(value))
      return
    }
    getListeIdNoeudAscendants(value)
  }

  const onSubmit = (event: SubmitEvent) => {
    event.preventDefault()
    const firstOption = inputValue ? (searchUnite(inputValue, noeuds)?.[0] ?? null) : null
    onChange(null, firstOption)
  }

  const filterOptions = (_: INoeudDimension[], state: FilterOptionsState<INoeudDimension>) => {
    return searchUnite(state.inputValue, noeuds)
  }

  const getOptionKey = (option: INoeudDimension | string) =>
    typeof option === 'string' ? option : option.identifiantNoeudDimension

  const renderOption: AutocompleteProps<INoeudDimension, false, false, true, 'div'>['renderOption'] = (
    params,
    option
  ) => {
    return (
      <span
        {...params}
        {...getLanguePourLesUnitesPasEnFrancais(option)}
      >
        {option.libelle}
      </span>
    )
  }

  return (
    <form onSubmit={onSubmit}>
      <Autocomplete
        clearText={'Effacer la saisie'}
        clearOnEscape
        options={noeuds}
        getOptionLabel={miseEnformeUniteName}
        renderOption={renderOption}
        filterOptions={filterOptions}
        getOptionKey={getOptionKey}
        aria-label={label}
        freeSolo
        size="small"
        onChange={onChange}
        value={inputValue ? searchUnite(inputValue ?? '', noeuds)?.[0] : null}
        renderInput={renderInputAccessibleGenerator(label, 'recherche-unites')}
      />
    </form>
  )
}
